import { View, StyleSheet, Pressable } from "react-native";
import { router, usePathname } from "expo-router";
import { ThemedText } from "@/components/ThemedText";
import { useTheme } from "@/hooks/useTheme";
import { MaterialCommunityIcons } from "@expo/vector-icons";
// import { StatusBadge } from "../StatusBadge";
import Avatar from "@/components/Avatar";

import { ShiftUser } from "@/types/db/shift_users";

interface UsersTabProps {
  shiftUsers?: ShiftUser[];
  shiftId?: string;
}

export function UsersTab({ shiftUsers, shiftId }: UsersTabProps) {
  const { colors } = useTheme();
  const pathname = usePathname();

  if (!shiftUsers || shiftUsers.length === 0) {
    return (
      <View style={styles.emptyContainer}>
        <MaterialCommunityIcons name="account-group" size={48} color={colors.placeholder} />
        <ThemedText style={[styles.emptyText, { color: colors.textSecondary }]}>No users assigned</ThemedText>
      </View>
    );
  }

  // const getStatusVariant = (status?: string) => {
  //   switch (status?.toUpperCase()) {
  //     case "ACCEPTED":
  //       return "accepted";
  //     case "DECLINED":
  //       return "declined";
  //     case "INVITED":
  //       return "pending";
  //     default:
  //       return "pending";
  //   }
  // };

  const handleUserPress = (userId: string) => {
    if (!shiftId) return;
    router.navigate(
      pathname.includes("/crew/")
        ? { pathname: "/crew/home/[shift]/user/[user]", params: { shift: shiftId, user: userId } }
        : { pathname: "/home/[shift]/user/[user]", params: { shift: shiftId, user: userId } },
    );
  };

  return (
    <View style={styles.container}>
      {shiftUsers.map((shiftUser) => {
        const user = shiftUser.user;
        const displayName = user
          ? user.preferred_name || `${user.first_name || ""} ${user.last_name || ""}`.trim() || user.email_address
          : "Unknown User";

        return (
          <Pressable
            key={shiftUser.id}
            onPress={() => handleUserPress(shiftUser.id)}
            style={({ pressed, hovered }) => [
              styles.userItem,
              { backgroundColor: colors.backgroundSecondary, borderColor: colors.border, cursor: "pointer" } as any,
              hovered && { backgroundColor: colors.card },
              pressed && { opacity: 0.7 },
            ]}
          >
            <Avatar userId={user?.id} firstName={user?.first_name} lastName={user?.last_name} size={36} />
            <View style={styles.userInfo}>
              <ThemedText style={styles.userName}>{displayName}</ThemedText>
            </View>
            {/* <StatusBadge
              variant={getStatusVariant(shiftUser.status)}
              text={shiftUser.status || "PENDING"}
              size="small"
            /> */}
            <MaterialCommunityIcons name="chevron-right" size={20} color={colors.textSecondary} />
          </Pressable>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 16,
    gap: 8,
  },
  emptyContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 32,
    gap: 8,
  },
  emptyText: {
    fontSize: 14,
  },
  userItem: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    padding: 12,
    borderRadius: 8,
    borderWidth: StyleSheet.hairlineWidth,
  },
  userInfo: {
    flex: 1,
  },
  userName: {
    fontSize: 14,
    fontWeight: "500",
  },
});
